import { normalizeHash, withUrlHash } from "@pathwright/utils/src/url/hash"
import path from "path-browserify"
import { LinkProps, LinkTo } from "./Link"

export function withHashTo(to: LinkTo, hashKey?: string): LinkTo {
  const hash = normalizeHash(hashKey)
  if (!hash) return to

  if (typeof to === "function") {
    return (location) => {
      const nextTo = to(location)

      return typeof nextTo === "string"
        ? withUrlHash(nextTo, hash)
        : {
            ...nextTo,
            hash
          }
    }
  }

  return typeof to === "string"
    ? withUrlHash(to, hash)
    : {
        ...to,
        hash
      }
}

export function resolveLinkPropsWithHash(
  linkProps: LinkProps | undefined,
  hashKey: string | undefined,
  basePath: string
): LinkProps | undefined {
  if (!linkProps || !hashKey) return linkProps

  if ("relativeTo" in linkProps && linkProps.relativeTo) {
    const { relativeTo, ...rest } = linkProps

    return {
      ...rest,
      to: withUrlHash(path.join(basePath, relativeTo), hashKey)
    }
  }

  if ("to" in linkProps && linkProps.to) {
    return {
      ...linkProps,
      to: withHashTo(linkProps.to, hashKey)
    }
  }

  if ("href" in linkProps && linkProps.href) {
    return {
      ...linkProps,
      href: withUrlHash(linkProps.href, hashKey)
    }
  }

  return linkProps
}
